// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__3bxjy","Hero-img":"Hero_Hero-img__1BX-T","reverse":"Hero_reverse__3R1M9"};